import admin from '../views/admin/index.vue'
import admin_create from '../views/admin/create.vue'
import admin_edit from '../views/admin/edit.vue'

const routes = [
  {
    path: "/admin",
    name: "admin",
    component: admin,
    meta: { authOnly: true },
  },
  {
    path: "/admin/create",
    name: "admin_create",
    component: admin_create,
    meta: { authOnly: true },
  },
  {
    path: "/admin/edit/:uuid",
    name: "admin_edit",
    component: admin_edit,
    meta: { authOnly: true },
  }]

export default routes
